

/* BEGIN three-day-tactical-backpack-buyer-highlights-20260731 */
;(function () {
  var expected = ["Robust 900D polyester, secure KAM buckles, all-over webbing, and shoulder-strap D-rings provide water-repellent, abrasion-resistant durability with expanded attachment options.","Removable side pouches and a detachable front waist bag expand organization; the front bag can also be carried separately as a waist or shoulder bag, and a covered hydration-tube outlet supports hydration routing.","An ergonomic mesh-padded back, top carry handle, adjustable chest strap (up to 60 in), adjustable waist belt (up to 55 in), and rescue-whistle buckle support breathable, comfortable carry and can help attract attention in an emergency."];
  function applyBuyerHighlights() {
    if (window.location.pathname.indexOf('/products/3-day-tactical-backpack') === -1) return;
    var box = document.querySelector('.auto-product__buyer-fit');
    if (!box) return;
    var items = box.querySelectorAll('li');
    if (items.length < 3) return;
    for (var i = 0; i < 3; i += 1) { if (items[i].textContent !== expected[i]) items[i].textContent = expected[i]; }
  }
  applyBuyerHighlights();
  [80, 250, 800, 1800, 4000].forEach(function (delay) { window.setTimeout(applyBuyerHighlights, delay); });
  new MutationObserver(applyBuyerHighlights).observe(document.documentElement, { childList: true, subtree: true });
})();
/* END three-day-tactical-backpack-buyer-highlights-20260731 */
